import { Card, Empty, Space } from 'antd';

interface KeyValuePairsType {
  cardTitle: string;
  data: {
    key: string;
    value: string | number;
    isLink?: boolean;
    href?: string;
  }[];
}
export default function KeyValuePairs({ cardTitle, data }: KeyValuePairsType) {
  return (
    <Card title={cardTitle}>
      {data?.length > 0 ? (
        <Space direction="vertical" size={15} className="w-full">
          {data?.map((item, index) => (
            <div
              key={`key-value-pair-${index.toString()}`}
              className="flex items-center justify-between gap-3 text-text-dark-gray"
            >
              {item?.key || '-'}
              {item?.isLink ? (
                <a
                  href={item?.href}
                  target="_blank"
                  rel="noreferrer"
                  className={`text-nowrap font-semibold`}
                >
                  {item?.value || '-'}
                </a>
              ) : (
                <div className="font-semibold">{item?.value || '-'}</div>
              )}
            </div>
          ))}
        </Space>
      ) : (
        <Empty />
      )}
    </Card>
  );
}
